<script lang="ts">
  const {
    page,
    perPage,
    count,
    onChange
  }: { page: number; perPage: number; count: number; onChange: (page: number) => void } = $props();

  const totalPages = $derived(Math.max(1, Math.ceil(count / perPage)));
</script>

{#if count > 0}
  <div class="flex items-center justify-between px-1 py-3 text-[12.5px] text-dark-gray">
    <span>{count} total &middot; page {page} of {totalPages}</span>
    <div class="flex gap-2">
      <button class="btn-secondary" disabled={page <= 1} onclick={() => onChange(page - 1)}> Previous </button>
      <button class="btn-secondary" disabled={page >= totalPages} onclick={() => onChange(page + 1)}> Next </button>
    </div>
  </div>
{/if}
